<template>
  <div class="data-import-update">
    <el-table :data="items" border style="width: 100%">
      <el-table-column type="selection" width="40"></el-table-column>
      <el-table-column prop="text" label="文本">
        <template v-slot="column">
          <a class="text" href="#" @click.prevent.stop="handleShowPop($event, column)"
            slot="reference" v-text="getRowText(column.row, 'text')"
            ></a>
        </template>
      </el-table-column>
      <el-table-column prop="pinyin" label="拼音">
        <template v-slot="column">
          <a class="text" href="#" @click.prevent.stop="handleShowPop($event, column)"
            slot="reference" v-text="getRowText(column.row, 'pinyin')"
            ></a>
        </template>
      </el-table-column>
      <el-table-column label="预览">
        <template v-slot="column">
          <PinyinPreview class="pinyin-preview" :text="column.row.text" :pinyin="column.row.pinyin"></PinyinPreview>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page="currentPage"
      :page-sizes="[10, 50, 100, 200]"
      :page-size="pageSize"
      layout="total, sizes, prev, pager, next, jumper"
      :total="total"
      v-if="total>pageSize"
    >
    </el-pagination>
    <el-popover ref="pop" placement="bottom" width="300" :reference="editElement">
      <PinyinInput v-model="editPinyin" :text="editText" type="textarea" :autosize="{minRows:1}" resize="none"></PinyinInput>
      <el-input v-model="editText" type="textarea" :autosize="{minRows:1}" resize="none"></el-input>
      <PinyinPreview class="pinyin-preview" :text="editText" :pinyin="editPinyin"></PinyinPreview>
      <div style="text-align: right; margin: 12px 0 0 0;">
        <el-button size="mini" type="text" @click="$refs.pop.doClose()">取消</el-button>
        <el-button type="primary" size="mini" @click="handleSubmit">确定</el-button>
      </div>
    </el-popover>
  </div>
</template>

<script>
export default {
  name: 'SentenceImport',
  components: {
    PinyinPreview: require('@/components/PinyinPreview').default,
    PinyinInput: require('@/components/PinyinInput').default,
  },
  data () {
    return {
      index: 1,
      items: [],
      total: 0,
      currentPage: 1,
      pageSize: 20,
      pageCount: 0,
      loading: false,
      editId: 0,
      editText: '',
      editPinyin: '',
      editElement: null,
      editItem: null
    }
  },
  created () {
    this.fetchData()
  },
  methods: {
    fetchData () {
      this.loading = true
      this.$http.get('api/data/index', {
        params: {
          page: this.currentPage,
          'per-page': this.pageSize,
        }
      }).then(res => {
        this.total = Number.parseInt(res.headers['x-pagination-total-count'])
        this.currentPage = Number.parseInt(res.headers['x-pagination-current-page'])
        this.pageCount = Number.parseInt(res.headers['x-pagination-page-count'])
        this.index = (this.currentPage - 1) * this.pageSize + 1
        this.items = res.data
        window.setTimeout(() => {
          this.loading = false
        }, 10)
      })
    },
    getRowText (row, key) {
      return row[key] ? row[key].replace(/\n/gm, '<br/>') : ''
    },
    showPop (event, col) {
      this.editItem = col.row
      this.editId = col.row.id
      this.editText = col.row.text
      this.editPinyin = col.row.pinyin
      this.editElement = event.target
      this.$refs.pop.referenceElm = this.editElement
      this.$refs.pop.doShow()
      window.setTimeout(() => {
        let nodes = this.$refs.pop.popperElm.querySelectorAll('textarea')
        if (nodes && nodes.length > 0) {
          nodes[nodes.length-1].focus()
        }
      }, 1)
    },
    handleShowPop (event, col) {
      if (this.$refs.pop.showPopper) {
        this.$refs.pop.handleBlur() 
        window.setTimeout(() => {
          this.showPop(event, col)
        }, 300)
      } else {
        this.showPop(event, col)
      }
    },
    handleSubmit () {
      if (!this.editText) return
      this.$http.post('api/data/update', {text: this.editText, pinyin: this.editPinyin}, {
        params: {id: this.editId}
      }).then(res => {
        this.$set(this.editItem, 'text', res.data.text)
        this.$set(this.editItem, 'pinyin', res.data.pinyin)
        this.$refs.pop.doClose()
      })
    },
    handleSizeChange (val) {
      this.pageSize = val
      this.currentPage = 1
      this.fetchData()
    },
    handleCurrentChange (val) {
      this.currentPage = val
      this.fetchData()
    }
  }
}
</script>

<style lang="scss">
.data-import-update{
  .text{
    color: #606266 !important;
    text-decoration: none;
    &:hover{
      text-decoration: underline;
    }
    &.empty{
      color: #E6A23C !important;
    }
  }
}
</style>